import { createSlice } from "@reduxjs/toolkit";
import { get, set } from "../../util/storage";

interface UserState {
  darkMode: boolean;
}

const initialState: UserState = {
  darkMode: false,
};

export const setDarkModeAndStorage =
  (val: boolean) =>
    async (dispatch: (arg0: { payload: any; type: string }) => void) => {
      set("darkMode", val);
      dispatch(setDarkMode(val));
    };

export const getInitialDarkModeVal = () => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  let res = await get("darkMode");
  if (res) {
    dispatch(setDarkMode(res));
  } else {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    dispatch(setDarkMode(prefersDark.matches));
  }
};

const userSlice = createSlice({
  name: "user",
  initialState,
  // non-async reducers
  reducers: {
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
    },
  },
});


export const { setDarkMode } = userSlice.actions;
export default userSlice.reducer;
